(function() {
    'use strict';

    angular
        .module('uniromaLandingApp')
        .controller('RegisterController', RegisterController);


    RegisterController.$inject = ['$translate', '$timeout', 'Auth', 'LoginService','Esterni','CodiceFiscaleService','$q','CategorieService','$window'];

    function RegisterController ($translate, $timeout, Auth, LoginService, Esterni,CodiceFiscaleService,$q,CategorieService,$window) {
        var vm = this;

        vm.doNotMatch = null;
        vm.error = null;
        vm.errorUserExists = null;
        vm.login = LoginService.open;
        vm.register = register;
        vm.registerAccount = {};
        vm.success = null;
        
        $timeout(function (){angular.element('#login').focus();});

        function register () {
            if (vm.registerAccount.password !== vm.confirmPassword) {
                vm.doNotMatch = 'ERROR';
            } else {
                vm.registerAccount.langKey = $translate.use();
                vm.doNotMatch = null;
                vm.error = null;
                vm.errorUserExists = null;
                vm.errorEmailExists = null;

                Auth.createAccount(vm.registerAccount).then(function () {
                    vm.success = 'OK';
                }).catch(function (response) {
                    vm.success = null;
                    if (response.status === 400 && response.data === 'login already in use') {
                        vm.errorUserExists = 'ERROR';
                    } else if (response.status === 400 && response.data === 'email address already in use') {
                        vm.errorEmailExists = 'ERROR';
                    } else {
                        vm.error = 'ERROR';
                    }
                });
            }
        }
        
        
        /**** Registrazione utente esterno ****/
        
        vm.utenteEsterno = {"fl_attivo":0, "codice_fiscale":null,documento_identita:null};
        vm.genderList = ['M','F'];
        vm.countryList = null;
        vm.savedCodFis = null;
        getCategorieList();
        
        function transformDate(date) {
        	var formatted = pad(date.getDate(), 2) + "/" + pad(date.getMonth() + 1, 2) + "/" + date.getFullYear();
        	return formatted;
        }
        
        function pad(n, width, z) {
        	z = z || '0';
        	n = n + '';
        	return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
        }
        
        Esterni.getCountryList({},function(response){
        	vm.countryList = response;
        });
        
        
        vm.createAccount = function(){
        	Esterni.save(vm.utenteEsterno, onSaveFinished, onSaveError);
        };
        
        var onSaveFinished = function (result) {
        	vm.success = true;
        	$window.scrollTo(0, 0);
        };
        
        var onSaveError = function (response) {
        	vm.success = null;
        	var errorType = response.headers('X-uniromaLandingApp-error')
            if (response.status === 400 &&  errorType === 'error.emailexists') {
                vm.errorEmailExists = 'ERROR';
            } else {
                vm.error = 'ERROR';
            }
        	$window.scrollTo(0, 0);
        };
        
        //Verifica che non esista già un esterno con il codice fiscale inserito
        vm.checkUniqueCodiceFiscale = function(codFis,docIdentita) {
        	var reqObject = {
        		codiceFiscale : codFis,
        		documentoIdentita: docIdentita,
        		nazionalita: vm.utenteEsterno.nazionalita
        	};
        	var isValid = false;
        	var deferred = $q.defer();
        	CodiceFiscaleService.checkUniqueCodiceFiscale.check( reqObject, function(resp) {
        		isValid = resp.isUnique;
        		if(isValid) {
        			deferred.resolve(isValid);
        		}
        		//Il codice fiscale esiste perchè è quello dell'utente corrente.
        		else if(vm.savedCodFis != null && vm.savedCodFis === codfis){
        			deferred.resolve(isValid);
        		}
        		else{
        			deferred.reject(false);
        		}
        	}, function(err) {
        			deferred.reject(false);
        	});
        	return deferred.promise;
        };
        
        //Verifica la validità del codice fiscale
        vm.checkCodiceFiscale = function(codfis) {
        	var isValid = false;
        	var deferred = $q.defer();
        	CodiceFiscaleService.checkCodiceFiscale.check( codfis, function(resp) {
        		isValid = resp.isValid;
        		if(isValid) {
        			deferred.resolve(isValid);
        		}
        		else {
        			deferred.reject(false);
        		}
        	}, function(err) {
        			deferred.reject(false);
        	});
        	return deferred.promise;
        };
        
        //Verifica la validità del codice fiscale rispetto alla data di nascita inserita
        vm.checkDateCodiceFiscale = function(dataNascita, codiceFiscale) {
        	var isValid = false;
        	var deferred = $q.defer();
        	var inputDate =  (dataNascita == null ? new Date() : dataNascita);
        	var payload = {
					"dataNascita": transformDate( inputDate ),
					"codiceFiscale" : codiceFiscale
			}; 
        	CodiceFiscaleService.checkDateCodiceFiscale.check( payload, function(resp) {
        	
        		isValid = resp.isValid;
        		if(isValid) {
        			deferred.resolve(isValid);
        		}
        		else {
        			deferred.reject(false);
        		}
        	}, function(err) {
        			deferred.reject(false);
        	});
        	return deferred.promise;
        };
        
        vm.changeStep = function(value){
        	vm.stepConfirmation = value;
            vm.error = null;
            vm.errorUserExists = null;
            vm.errorEmailExists = null;
            vm.success = null;
            vm.checkConsenso = false;
        }
        
        //Verifica la validità del codice fiscale rispetto al genere inserito
        vm.checkGenderCodFiscale = function(gender,codiceFiscale){
        	var isValid = false;
        	var deferred = $q.defer();
        	
        	if(codiceFiscale.length>=10){
        		var giornoNascita = codiceFiscale.substring(9,11);
        		if( (giornoNascita>=40 && gender==='F') || (giornoNascita<40 && gender==='M') ){
        			isValid = true;
        			deferred.resolve(isValid);
        		}
        		else{
        			deferred.reject(false);
        		}
        	}
        	return deferred.promise;
        };
        
        function getCategorieList(){
        	CategorieService.external.get({}, function(resp) {
        		vm.categoryList = resp;
        		for(var i=0;i<resp.length;i++){
        			if(resp[i].sottoCategoria.toUpperCase() === "VISITATORE"){
        				vm.utenteEsterno.categoria = resp[i];
        				break;
        			}
        		}
        	}, function(err) {
        		deferred.reject(false);
        	});
        }
    }
})();
